import { render, staticRenderFns } from "./ADeviceDetail2.vue?vue&type=template&id=58ba4918&scoped=true"
import script from "./ADeviceDetail2.vue?vue&type=script&lang=js"
export * from "./ADeviceDetail2.vue?vue&type=script&lang=js"
import style0 from "./ADeviceDetail2.vue?vue&type=style&index=0&id=58ba4918&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ba4918",
  null
  
)

export default component.exports